import React from "react";
import { Link } from "react-router-dom";
import { Clapperboard, Network, Mic2, ArrowRight, UserCheck } from "lucide-react";
import { Section, Eyebrow, H1, H2, Lead, ButtonPrimary, GlassCard } from "../components/ui-kit";
import ScoutingPortalMock from "../components/ScoutingPortalMock";

export default function ContentAgency() {
  return (
    <div>
      <Section className="!pt-16">
        <Eyebrow>Vertical 03 · Career Ecosystem</Eyebrow>
        <H1>From gameplay to <span className="text-gradient-orange">digital IP</span>.</H1>
        <Lead className="mt-6">
          Perforange is part production house, part scouting agency. We help students monetize their craft, and we help organizations sign verified talent — with classroom-grade proof.
        </Lead>
      </Section>

      <Section className="!pt-0">
        <div className="grid md:grid-cols-2 gap-6">
          {[
            { icon: Clapperboard, t: "Production House", d: "VOD editing, thumbnails, shortform factory, creator IP licensing — a studio-in-a-box for every school lab." },
            { icon: Mic2, t: "Shoutcasting Lab", d: "Commentary coaching in English, Hindi, Tamil, Bengali, and more." },
            { icon: Network, t: "The Ecosystem", d: "Students are free to move laterally through the career pathways, explore their specific strengths and monetize their IP." },
            { icon: UserCheck, t: "Talent Representation", d: "Agency services for athletes from our school pipeline who are ready for the next stage." },
          ].map((x, i) => {
            const Icon = x.icon;
            return (
              <GlassCard key={i} className="hover:border-[#FF8C00]/40 transition-all" data-testid={`agency-${i}`}>
                <div className="flex items-start gap-4">
                  <div className="w-12 h-12 rounded-xl bg-[#FF8C00]/10 border border-[#FF8C00]/30 flex items-center justify-center shrink-0">
                    <Icon className="w-6 h-6 text-[#FF8C00]" />
                  </div>
                  <div>
                    <h3 className="font-display font-black text-xl text-white">{x.t}</h3>
                    <p className="mt-2 text-sm text-[#A1A1AA]">{x.d}</p>
                  </div>
                </div>
              </GlassCard>
            );
          })}
        </div>
      </Section>

      <Section className="!pt-0">
        <div className="max-w-3xl mb-8">
          <Eyebrow>Scouting Portal</Eyebrow>
          <H2>A control room for signing decisions.</H2>
          <Lead className="mt-4">
            Every athlete profile is backed by certified Perforange metrics: wellness, Pro-Path level, tournament record, and behavior score.
          </Lead>
        </div>
        <ScoutingPortalMock />
      </Section>

      <Section className="!pt-0">
        <GlassCard className="md:flex items-center justify-between gap-6">
          <div>
            <H2 className="!text-3xl">Partner as an eSports Org.</H2>
            <p className="mt-3 text-[#A1A1AA]">Get early access to the Scouting Portal and co-brand with India&apos;s leading school-gaming pipeline.</p>
          </div>
          <Link to="/contact?type=partner" data-testid="agency-cta-partner">
            <ButtonPrimary className="mt-4 md:mt-0">Request Partner Access <ArrowRight className="w-4 h-4" /></ButtonPrimary>
          </Link>
        </GlassCard>
      </Section>
    </div>
  );
}
